class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"]'),
      form: this.querySelector('form'),
    };

    this.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();

    // update hidden input value
    this.elements.input.value = event.currentTarget.dataset.value;

    // submit form
    this.elements.form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
